module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Kg6IN/tc-custom/9781398479487.jpg?1705687860596",
      "alt": "This image is the cover for the book The Broken King"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Broken King\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Far from his home in the Kingdom of Ferinatia, Thorn continues his journey through the dying world of Elcina and the plan to bring the disunited realms and peoples together that he may guide them from the dying world into the safety of his own. With the kingdoms of Isthia and Taroth behind him, and the unexpected departure of the Ranee, Thorn enters the land of the Keegan nomads accompanied by the wolf pup Rark and the living crystal Lorak Ledel intent on finding a way to unify the tribes to his cause and find Princess Ranee who fled here after the destruction in Rata. Meanwhile, the Kingdom of Varth prepares for their invasion of his world and his own kingdom. Secretly controlled by the Sorcerer Tarna, now emboldened by the murder of Thorn’s friend Penias, who was known as the Crown Prince Jarel Whitethorn. As Thorn enters the nomad lands, the Varthians stretch out their hand against the nomads and all other kingdoms and peoples who would stand against them, and their sorcerous leader.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      D. N. Bruce\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("D. N. Bruce lives and works on the south coast of New South Wales, Australia. He splits his free time between Christian activities, time with friends and family, occasional computer games and movies, and writing.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0